/**
 * Cart gift redemption (CDR Group 3.0 / Tevo Sports).
 * Event-delegated + idempotent: #CartDrawer's contents are replaced wholesale by
 * cart-drawer.js on every add-to-cart, so nothing here binds listeners directly
 * to nodes that can be swapped out. Everything is delegated from `document`.
 * Integrates with the theme's existing Ajax Cart API + pub/sub, never touches
 * window.fetch/XMLHttpRequest globally.
 */
(function () {
  function launchGiftConfetti() {
  if (
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  var colors = ['#ff5a00', '#ffcb05', '#ffffff', '#111111'];

  for (var i = 0; i < 150; i++) {
    var piece = document.createElement('span');

    piece.className = 'cdr-gift-confetti';
    piece.style.backgroundColor = colors[i % colors.length];
    piece.style.setProperty(
      '--x',
      ((Math.random() - 0.5) * 520) + 'px'
    );
    piece.style.setProperty(
      '--y',
      (160 + Math.random() * 380) + 'px'
    );
    piece.style.setProperty(
      '--rotation',
      ((Math.random() - 0.5) * 1000) + 'deg'
    );
    piece.style.setProperty(
      '--delay',
      (Math.random() * 0.15) + 's'
    );

    document.body.appendChild(piece);

    window.setTimeout(function (element) {
      element.remove();
    }, 1800, piece);
  }
}
  var isRedeeming = false;
  var giftModalEscapeHandled = false;
  var lastTrigger = null;

  function getModal() {
    return document.getElementById('CartGiftModal');
  }

  function getCartDrawerEl() {
    return document.querySelector('cart-drawer');
  }

  function isModalOpen() {
    var modal = getModal();
    return !!modal && !modal.hidden;
  }

  function getConfig(modal) {
    var el = modal.querySelector('[data-cdr-gift-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function openModal(trigger) {
    var modal = getModal();
    if (!modal) return;
    lastTrigger = trigger || lastTrigger;
    modal.hidden = false;
    var dialog = modal.querySelector('.cdr-gift-modal__dialog');
    trapFocus(dialog, modal.querySelector('.cdr-gift-modal__close'));
  }

  function closeModal() {
    var modal = getModal();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    // #CartDrawer gets replaced wholesale on every add-to-cart (including our
    // own redeem call), which can detach the node `lastTrigger` was captured
    // from. Re-resolve by id first so focus doesn't silently land on <body>.
    var target = document.getElementById('CartGiftTrigger') || lastTrigger;
    removeTrapFocus(target);
  }

  function setCardBusy(card, busy, text) {
    var cta = card.querySelector('[data-cdr-gift-redeem]');
    var textEl = card.querySelector('.cdr-gift-card__cta-text');
    if (!cta) return;
    cta.disabled = busy;
    card.classList.toggle('cdr-gift-card--loading', !!busy);
    if (text && textEl) textEl.textContent = text;
  }

  function setCardError(card, text) {
    card.classList.add('cdr-gift-card--error');
    var cta = card.querySelector('[data-cdr-gift-redeem]');
    var textEl = card.querySelector('.cdr-gift-card__cta-text');
    if (cta) cta.disabled = false;
    if (textEl && text) textEl.textContent = text;
  }

  function patchModalFromSectionHtml(sectionHtml) {
    if (!sectionHtml) return;
    var modal = getModal();
    if (!modal) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var freshModal = doc.getElementById('CartGiftModal');
    if (!freshModal) return;
    var wasOpen = !modal.hidden;
    modal.innerHTML = freshModal.innerHTML;
    modal.hidden = !wasOpen;
  }

  function redeemGift(card) {
    if (isRedeeming) return;
    var variantId = card.getAttribute('data-variant-id');
    if (!variantId) return;

    var modal = getModal();
    var config = modal ? getConfig(modal) : null;
    var labels = (config && config.labels) || {};
    var giftIds = (config && config.giftProductIds) || [];

    isRedeeming = true;
    setCardBusy(card, true, labels.redeeming || 'Resgatando...');

    var cartDrawerEl = getCartDrawerEl();
    var sections = cartDrawerEl && typeof cartDrawerEl.getSectionsToRender === 'function'
      ? cartDrawerEl.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    // Last-moment re-check against the live cart: closes the race window where
    // a stale modal (e.g. a second tab) could otherwise add a second gift.
    fetch(window.routes.cart_url + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (liveCart) {
        var alreadyHasGift = liveCart.items.some(function (item) {
          return !!(item.properties && item.properties._cdr_gift) || giftIds.indexOf(item.product_id) !== -1;
        });
        if (alreadyHasGift) {
          var err = new Error('gift-already-in-cart');
          err.alreadyHasGift = true;
          throw err;
        }

        var addConfig = fetchConfig('json');
        addConfig.body = JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: { _cdr_gift: 'true' },
            },
          ],
          sections: sections.join(','),
          sections_url: window.location.pathname,
        });

        return fetch(window.routes.cart_add_url, addConfig).then(function (response) {
          return response.json();
        });
      })
      .then(function (response) {
        if (!response) return;
        if (response.status) {
          setCardBusy(card, false);
          setCardError(card, labels.error || 'Tentar novamente');
          return;
        }

        launchGiftConfetti();


        if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
          cartDrawerEl.renderContents(response);
        }
        if (response.sections && response.sections['cart-drawer']) {
          patchModalFromSectionHtml(response.sections['cart-drawer']);
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-gift-redemption',
          cartData: response,
        });
      })
      .catch(function (err) {
        setCardBusy(card, false);
        setCardError(card, labels.error || 'Tentar novamente');
        if (err && err.alreadyHasGift) {
          // Someone else already redeemed in this same cart: pull the real
          // section state so every card flips to "Resgatado" instead of
          // silently retrying.
          fetch(window.routes.cart_url + '?section_id=cart-drawer')
            .then(function (r) {
              return r.text();
            })
            .then(function (html) {
              patchModalFromSectionHtml(html);
            })
            .catch(function () {});
        }
      })
      .finally(function () {
        isRedeeming = false;
      });
  }

  function removeCartLines(lines) {
    if (!lines || !lines.length) return;

    var cartDrawerEl = getCartDrawerEl();
    var sections = cartDrawerEl && typeof cartDrawerEl.getSectionsToRender === 'function'
      ? cartDrawerEl.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    var updates = {};
    lines.forEach(function (line) {
      updates[line.key] = 0;
    });

    var body = JSON.stringify({
      updates: updates,
      sections: sections.join(','),
      sections_url: window.location.pathname,
    });

    fetch(window.routes.cart_update_url, Object.assign(fetchConfig(), { body: body }))
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
          cartDrawerEl.renderContents(response);
        }
        if (response.sections && response.sections['cart-drawer']) {
          patchModalFromSectionHtml(response.sections['cart-drawer']);
        }
        publish(typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : 'cart-update', {
          source: 'cart-gift-redemption',
          cartData: response,
        });
      })
      .catch(function () {});
  }

  /**
   * Two independent checks, both belt-and-suspenders against the PDP/quick-add
   * path (which never sets `_cdr_gift`, unlike the modal's redeem button):
   *  1. Any line matching a configured gift product WITHOUT the `_cdr_gift`
   *     property is illegitimate — it bypassed the redeem flow entirely — and
   *     is removed regardless of how many eligible items are in the cart.
   *  2. A legitimately-redeemed gift line (has the property) is still removed
   *     if the eligible count later drops below the minimum (pre-existing
   *     behavior, e.g. the shopper removed a shirt after redeeming).
   */
  function autoRemoveIfIneligible(cartData) {
    if (!cartData || !cartData.items) return;
    var modal = getModal();
    var config = modal ? getConfig(modal) : null;
    if (!config || !config.autoRemove) return;

    var giftIds = config.giftProductIds || [];
    var excludeKeywords = (config.excludeKeywords || []).map(function (k) {
      return String(k).toLowerCase().trim();
    }).filter(Boolean);
    var minItems = config.minItems || 3;

    var legitGiftLine = null;
    var illegitGiftLines = [];
    var eligibleCount = 0;

    cartData.items.forEach(function (item) {
      var hasGiftProperty = !!(item.properties && item.properties._cdr_gift);
      var isGiftProduct = giftIds.indexOf(item.product_id) !== -1;

      if (hasGiftProperty || isGiftProduct) {
        if (hasGiftProperty) {
          if (!legitGiftLine) legitGiftLine = item;
        } else {
          illegitGiftLines.push(item);
        }
        return;
      }

      var titleDown = String(item.product_title || item.title || '').toLowerCase();
      var excluded = excludeKeywords.some(function (kw) {
        return kw && titleDown.indexOf(kw) !== -1;
      });
      if (!excluded) eligibleCount += item.quantity;
    });

    var linesToRemove = illegitGiftLines.slice();
    if (legitGiftLine && eligibleCount < minItems) {
      linesToRemove.push(legitGiftLine);
    }

    removeCartLines(linesToRemove);
  }

  function getSelectedVariant(card) {
    var variantsEl = card.querySelector('[data-cdr-gift-variants]');
    if (!variantsEl) return null;
    var variants;
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      return null;
    }

    var selects = Array.prototype.slice.call(card.querySelectorAll('.cdr-gift-card__option'));
    var values = {};
    var complete = true;
    selects.forEach(function (select) {
      var pos = select.getAttribute('data-option-position');
      if (!select.value) complete = false;
      values[pos] = select.value;
    });
    if (!complete) return { complete: false, variant: null };

    var match = variants.find(function (v) {
      return (!values['1'] || v.option1 === values['1']) &&
        (!values['2'] || v.option2 === values['2']) &&
        (!values['3'] || v.option3 === values['3']);
    });

    return { complete: true, variant: match || null };
  }

  function handleOptionChange(select) {
    var card = select.closest('[data-cdr-gift-card]');
    if (!card) return;
    var modal = getModal();
    var config = modal ? getConfig(modal) : null;
    var labels = (config && config.labels) || {};

    var result = getSelectedVariant(card);
    var cta = card.querySelector('[data-cdr-gift-redeem]');
    var textEl = card.querySelector('.cdr-gift-card__cta-text');
    if (!cta) return;

    if (!result.complete) {
      cta.disabled = true;
      if (textEl) textEl.textContent = labels.chooseOption || 'Escolha as opções';
      return;
    }
    if (!result.variant || !result.variant.available) {
      cta.disabled = true;
      if (textEl) textEl.textContent = labels.unavailable || 'Indisponível';
      return;
    }
    card.setAttribute('data-variant-id', result.variant.id);
    cta.disabled = false;
    if (textEl) textEl.textContent = labels.redeem || 'Resgatar';
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cdr-gift-trigger]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    var closer = event.target.closest('[data-cdr-gift-close]');
    if (closer) {
      event.preventDefault();
      closeModal();
      return;
    }

    var redeemBtn = event.target.closest('[data-cdr-gift-redeem]');
    if (redeemBtn && !redeemBtn.disabled) {
      event.preventDefault();
      var card = redeemBtn.closest('[data-cdr-gift-card]');
      if (card) redeemGift(card);
      return;
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.classList && event.target.classList.contains('cdr-gift-card__option')) {
      handleOptionChange(event.target);
    }
  });

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Escape' && isModalOpen()) {
        giftModalEscapeHandled = true;
        event.stopPropagation();
        closeModal();
      }
    },
    true
  );

  document.addEventListener(
    'keyup',
    function (event) {
      if (event.code === 'Escape' && giftModalEscapeHandled) {
        giftModalEscapeHandled = false;
        event.stopPropagation();
      }
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source === 'cart-gift-redemption') return;

      // Runs on every cart change now (not just source === 'cart-items'):
      // a gift product added outside the redeem flow (PDP, quick-add, a
      // stale link) never sets `_cdr_gift`, so it must be caught no matter
      // which part of the theme triggered the update.
      if (event.cartData && event.cartData.items) {
        autoRemoveIfIneligible(event.cartData);
      }

      if (event.cartData && event.cartData.sections && event.cartData.sections['cart-drawer']) {
        patchModalFromSectionHtml(event.cartData.sections['cart-drawer']);
      }
    });
  }

  // Catches a gift line that was already sitting in the cart when this page
  // loaded (e.g. added in an earlier visit) — otherwise the check above only
  // runs on the next cart-changing action, which the shopper might skip by
  // going straight to checkout.
  function initialCartCheck() {
    fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { autoRemoveIfIneligible(cart); })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialCartCheck);
  } else {
    initialCartCheck();
  }
})();
